'use strict'
const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))

module.exports = class htmlTableWidget extends Base {

	onInit() {

		if (typeof this._data !== 'object') {
			this._data = {html: this._data}
		}

		this.listen()

		this.btns = {}
		this.allButtons()

		this.onchange()

	}

	listen() {
		this._widget.querySelectorAll('td').forEach(el => {
			if (!el) { return }
			el.setAttribute('contenteditable', '')
			this.listener(el)
		})
	}

	onDestroy() {
		this._widget.querySelectorAll('td').forEach(el => {
			if (!el) { return }
			el.removeAttribute('contenteditable')
		})
	}

	onSave() {
		this._widget.querySelectorAll('td').forEach(el => {
			if (!el) { return }
			el.removeAttribute('contenteditable')
		})
	}

	allButtons() {

		function i(text) {
			return '<i class="material-icons">' + text + '</i>'
		}

		function space() {
			let el = document.createElement('span')
			el.className = 'btn-space'
			return el
		}

		let buttons = [
			this.addButton(i('border_bottom'),
				this.cellAddBottom.bind(this)),
			this.addButton(i('vertical_align_top'),
				this.cellRemoveBottom.bind(this)),
			space(),
			this.addButton(i('border_right'),
				this.cellAddRight.bind(this)),
			this.addButton(i('format_textdirection_r_to_l'),
				this.cellRemoveRight.bind(this)),
			space(),
			this.addButton(i('format_align_left'), 'justifyLeft'),
			this.addButton(i('format_align_center'), 'justifyCenter'),
			this.addButton(i('format_align_right'), 'justifyRight'),
			this.addButton(i('format_align_justify'), 'justifyFull'),
			space(),
			this.addButton(i('format_bold'), 'bold'),
			this.addButton(i('format_italic'), 'italic'),
			this.addButton(i('format_underline'), 'underline'),
			this.addButton(i('link'), (active) => {
				if (active) {
					this._doc.execCommand('unlink')
				} else {
					this.formLink()
				}
			}, 'anchor'),
			space(),
			this.addButton(i('format_list_bulleted'), 'insertUnorderedList'),
			this.addButton(i('format_list_numbered'), 'insertOrderedList'),

		]

		buttons.forEach((btn) => {
			this._elemButtons.appendChild(btn)
		})

	}

	cellAddBottom() {
		const tr = document.createElement('tr')
		const td = '<td contenteditable></td>'
		this._widget.querySelector('tr').querySelectorAll('td').forEach(el => {
			if (!el) { return }
			tr.innerHTML += td
		})
		this._widget.querySelector('tbody').appendChild(tr)
		this.listen()
	}

	cellRemoveBottom() {
		if (this._widget.querySelectorAll('tbody tr').length < 2) {
			return
		}
		this._widget.querySelector('tbody tr:last-child').remove()
	}

	cellAddRight() {
		const td = document.createElement('td')
		td.setAttribute('contenteditable', '')
		this._widget.querySelectorAll('tr').forEach(el => {
			if (!el) { return }
			el.appendChild(td.cloneNode())
		})
		this.listen()
	}

	cellRemoveRight() {
		if (this._widget.querySelector('tbody tr')
			.querySelectorAll('td').length < 2) {
			return
		}
		this._widget.querySelectorAll('tbody tr').forEach(el => {
			if (!el) { return }
			el.querySelector('td:last-child').remove()
		})
	}

	addButton(text, command, block) {
		let button = document.createElement('button')
		button.className = 'formater'
		button.innerHTML = text
		button.onclick = () => {
			if (typeof command === 'string') {
				this._doc.execCommand(command, false, block)
			}
			if (typeof command === 'function') {
				command(button.hasAttribute('active'))
			}
			this.onchange()
		}
		button.active = (is) => {
			if (is) { button.setAttribute('active', '') }
			else { button.removeAttribute('active') }
		}
		this.btns[block || command] = button
		return button
	}

	getSelection() {
		return this._doc.defaultView.getSelection()
	}

	containsNode(name, node) {

		if (!node) {
			if (!this.getSelection().focusNode) { return }
			node = this.getSelection().focusNode.parentNode
		}

		if (node.nodeName === 'BODY') {
			return
		}

		if (!node || node.hasAttribute('contenteditable')) {
			return false
		}
		if (node.nodeName === name) {
			return true
		}
		return this.containsNode(name, node.parentNode)
	}

	onchange() {

		let isSelected = () => {
			let s = this.getSelection()
			return s.anchorOffset - s.focusOffset !== 0
		}


		this.btns.bold.active(this.containsNode('B'))
		this.btns.italic.active(this.containsNode('I'))
		this.btns.underline.active(this.containsNode('U'))
		this.btns.anchor.active(this.containsNode('A'))

		this.btns.bold.disabled = !isSelected()
		this.btns.italic.disabled = !isSelected()
		this.btns.underline.disabled = !isSelected()

		this._data.html = '<table>' +
			this._widget.querySelector('table').innerHTML
				.replace(/contenteditable=""/ig, '') +
			'</table>'

	}

	listener(element) {
		element.addEventListener("blur", (e) => { this.onchange(e) })
		element.addEventListener("keyup", (e) => { this.onchange(e) })
		element.addEventListener("paste", (e) => { this.onpaste(e) })
		element.addEventListener("copy", (e) => { this.onchange(e) })
		element.addEventListener("cut", (e) => { this.onchange(e) })
		element.addEventListener("delete", (e) => { this.onchange(e) })
		element.addEventListener("mouseup", (e) => { this.onchange(e) })
		element.addEventListener("click", (e) => { this.onchange(e) })
	}

	onpaste(e) {
		e.preventDefault()
		let text = e.clipboardData.getData('text/html') ||
			e.clipboardData.getData('text')
		const div = document.createElement('div')
		div.innerHTML = text
		this._doc.execCommand('insertHTML', false, div.innerText)
		this.onchange(e)
	}

	formLink() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let text = document.createElement('input')
		let url = document.createElement('input')
		url.setAttribute('type', url)
		url.value = 'http://'

		div.appendChild(forms.input('Text', text))
		div.appendChild(forms.input('Url', url))

		let s = this.getSelection()
		if (s.extentOffset !== s.baseOffset) {
			text.value = s.toString().replace(/\n/ig, '')
		}

		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Vlozit odkaz'
		button.onclick = () => {
			if (!url.value) { return }
			if (text.value) {
				this._doc.execCommand('insertHTML', false,
					'<a href="' + url.value + '" target="_blank">' + text.value + '</a>')
			} else {
				this._doc.execCommand('createLink', false, url.value)
			}
			modal.hide()
		}
		block.appendChild(forms.actions(button))

		let title = 'Pridat odkaz'
		modal.show(title, block).then(() => { text.focus() })

	}


}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/html-table/html-table.edit.js
// module id = 455
// module chunks = 0